<template>
    <div>
        <el-card>

<!--            <div slot="header">-->
<!--                <router-link :to="{ path:'/systemFeishuUserAdd', query:{callback: request,id:id,type:type}}">-->
<!--                    <el-button type="primary" >添加人员</el-button>-->
<!--                </router-link>-->
<!--               -->
<!--            </div>-->
            <el-form :inline="true" :model="form" class="search-form" @keyup.enter.prevent="searchEvent">

                <el-form-item label="人员搜索:" >
                    <el-input v-model="form.keyword" placeholder="请输入人员..." clearable @keyup.enter.native="searchEvent"  class="common-input"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchEvent">查询</el-button>
<!--                    <el-button type="primary" @click="reset">重置</el-button>-->
                    <router-link :to="{ path:'/systemFeishuUserAdd', query:{callback: request,id:id,type:type}}">
                        <el-button type="primary" >添加人员</el-button>
                    </router-link>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card>

            <el-table :data="tableData" border v-loading='loading'>

                <el-table-column type="index" width="50"></el-table-column>

                <el-table-column label="用户名 " prop="internalUserid"></el-table-column>

                <el-table-column label="真实姓名" prop="name"></el-table-column>

                <el-table-column label="所在部门" prop="departmentName"></el-table-column>
                <el-table-column label="审批优先级" prop="priority"></el-table-column>

                <el-table-column label="操作" v-if='type === "group"'>
                    <template slot-scope='scope'>
                        <el-button type="text" @click="editEvent(scope.row.user_group_id,scope.row.priority)">编辑</el-button>
                        <el-button class="table-del-btn" type="text" @click="deleteRole(scope.$index, tableData, scope.row.internalUserid, scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
        <el-dialog title="审批优先级编辑" :visible.sync="dialogFormVisible">
            <el-form label-width="100px" v-model="dialogForm">
                <br/>
                <el-form-item label="审批优先级:"  >
                    <el-input v-model="dialogForm.priority" type="number" min="1"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <!--<el-card>-->

            <!--<el-dialog width="30%" title="添加人员" :visible.sync="innerVisible" append-to-body>-->
                <!--<systemUserAdd :id='id' :type='type' :callback='request' @closePopOut='closePopOut'/>-->
            <!--</el-dialog>-->

        <!--</el-card>-->
    </div>
</template>

<script>
import services from './system.services.js'
import systemUserAdd from './systemUserAdd'
export default {

    computed: {
        query() {
            return this.$route.query
        },
        id() {
            return +this.query.id
        },
        type() {
            return this.query.type
        },
        callback() {
            return this.query.callback
        }
    },

    components: {systemUserAdd},

    data() {
        return {
            loading: true,
            tableData: [],
            form:{
                pageSize:10,
                pageIndex:1,
                keyword:''
            },
            dialogFormVisible:false,
            total:0,
            dialogForm:{
                user_group_id:'',
                priority:1
            }

        }
    },

    mounted() {
        this.request()
    },

    methods: {
        searchEvent(){
            this.form.pageIndex = 1
            this.request()
        },
        // 请求数据
        request() {
            if(this.type === 'group') {
                let params={
                    ...this.form,
                    groupId:this.id

                }
                this.getuser(services.groupUser, params)
            } else {
                this.getuser(services.departmentUser, { departmentId: this.id })
            }
        },

        // 获取人员
        getuser(request, params) {
            request(params)
                .then(res => {
                    this.tableData = res.list
                    this.total = res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // // 关闭弹框
        // closePopOut(info) {
        //     this.innerVisible = info;
        // },
        editEvent(user_group_id,priority){
            this.dialogForm.user_group_id = user_group_id
            this.dialogForm.priority = priority
            this.dialogFormVisible = true
        },
        dialogFormSubmit(){
            // console.log(this.dialogForm)
            // groupPriorityEdit
            this.dialogForm.priority = Number(this.dialogForm.priority)
            services.groupPriorityEdit(this.dialogForm)
            .then(() => {
                this.$message.success('修改成功！')
                this.request()
            })
           .catch(err => this.$message.error(err.message))
            this.dialogFormVisible = false
        },
        // 删除某一项
        deleteRole(index, rows, user, id) {
            this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    services.userGroupDelete({ groupId: this.id, internalUserid: [user] })
                        .then(res => {
                            rows.splice(index, 1);
                            this.$message.success('删除成功')
                        })
                }).catch(() => this.$messag.info('已取消删除'));
        },
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request()
        },
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
